import { FC } from 'react'
import { Button } from './Button'
import { useTranslation } from 'react-i18next'

interface Props {
  onClick: () => void
  disabled?: boolean
}

export const ResetButton: FC<Props> = ({ onClick, disabled }) => {
  const { t } = useTranslation()

  return (
    <Button
      className="px-4 text-sm font-medium text-neutral-900 enabled:bg-primary-100 enabled:text-primary-700 enabled:border-primary-300"
      onClick={onClick}
      disabled={disabled}
      variant="outlined"
    >
      {t('common.reset')}
    </Button>
  )
}
